/**
 * Builds public URL for an event page.
 * Prefers company-scoped routes when slug is known; otherwise uses /event/:id.
 */
export function getEventPath(event, company = null) {
  if (!event?.Id && !event?.id) {
    return null;
  }

  const eventId = event.Id ?? event.id;
  const slug =
    company?.Slug ||
    event.SlugCompany ||
    event.CompanySlug ||
    event.Slug ||
    null;
  const idType =
    company?.IdType ??
    event.CompanyIdType ??
    event.IdTypeCompany ??
    null;

  if (slug && idType != null) {
    if (idType === 1) {
      return `/company/${slug}/event/${eventId}`;
    }
    if (idType === 2) {
      return `/obrazovanie-v-bashkortostane/vuzy-rb/${slug}/event/${eventId}`;
    }
    if (idType === 3) {
      return `/obrazovanie-v-bashkortostane/kolledzhi-rb/${slug}/event/${eventId}`;
    }
    if (idType === 4) {
      return `/obrazovanie-v-bashkortostane/shkoly-rb/${slug}/event/${eventId}`;
    }
  }

  return `/event/${eventId}`;
}
